export default "__VITE_ASSET__ceKt_yEK__"